var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:_vm.$style.header},[_c('router-link',{class:_vm.$style.logo,attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../../../assets/images/lira-logo.png"),"alt":"Intranet Logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }